export default __webpack_public_path__ + "static/media/icon-load-peak-shaving.7fe1daf3.svg";